module.exports = __webpack_public_path__ + "img/h数据建模.b2cea132.svg";